"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarViewModelFactory = void 0;
const WeekViewModel_1 = require("../compound/WeekViewModel");
const MonthViewModel_1 = require("../compound/MonthViewModel");
const WeekDayNameViewModel_1 = require("../base/WeekDayNameViewModel");
const SlotViewModel_1 = require("../base/SlotViewModel");
const SectionSlotViewModel_1 = require("../section/SectionSlotViewModel");
const SectionDayViewModel_1 = require("../section/SectionDayViewModel");
const DayViewModel_1 = require("../base/DayViewModel");
class CalendarViewModelFactory {
    constructor(calVModel, configuration, stringsProvider) {
        this.calVModel = calVModel;
        this.configuration = configuration;
        this.stringsProvider = stringsProvider;
    }
    createModel(type, params) {
        switch (type) {
            case 'day':
                return this._getDayViewModel(params);
            case 'slot':
                return this._getSlotViewModel(params);
            case 'week':
                return this._getWeekViewModel(params);
            case 'month':
                return this._getMonthViewModel(params);
            case 'weekDayName':
                return this._getWeekDayNameViewModel(params);
            case 'sectionSlots':
                return this._getSectionSlotsViewModel(params);
            case 'sectionDays':
                return this._getSectionDaysViewModel(params);
            default:
                return null;
        }
    }
    _getDayViewModel(dayParams) {
        return new DayViewModel_1.DayViewModel(dayParams, this.calVModel, this.configuration, this.stringsProvider);
    }
    _getWeekViewModel(weekParams) {
        return new WeekViewModel_1.WeekViewModel(weekParams);
    }
    _getMonthViewModel(monthParams) {
        return new MonthViewModel_1.MonthViewModel(monthParams, this.stringsProvider);
    }
    _getWeekDayNameViewModel(weekDayNameParams) {
        return new WeekDayNameViewModel_1.WeekDayNameViewModel(weekDayNameParams, this.stringsProvider);
    }
    _getSlotViewModel(slotParams) {
        return new SlotViewModel_1.SlotViewModel(slotParams, this.calVModel, this.configuration, this.stringsProvider);
    }
    _getSectionSlotsViewModel(sectionSlotsParams) {
        return new SectionSlotViewModel_1.SectionSlotViewModel(this.calVModel, this.configuration, this.stringsProvider);
    }
    _getSectionDaysViewModel(sectionDayParams) {
        return new SectionDayViewModel_1.SectionDayViewModel(this.calVModel, this.configuration, this.stringsProvider);
    }
}
exports.CalendarViewModelFactory = CalendarViewModelFactory;
